const UserReducer = (state, action) => {
  switch (action.type) {
    case "SET_DATA":
      console.log("Set Data in reducer ftn in Userreducer!!");

      return {
        ...state,
        users: action.payload,
      };

    case "SET_SINGLE_USER":
      const user = action.payload.filter((item) => {
        return item.id === action.id;
      });
      
      return {
        ...state,
        singleUser: user,
      };

    default:
      return state;
  }
};

export default UserReducer;
